import { render } from "./HorizontalCard.vue?vue&type=template&id=391b6db2&scoped=true"
import script from "./HorizontalCard.vue?vue&type=script&lang=js"
export * from "./HorizontalCard.vue?vue&type=script&lang=js"

import "./HorizontalCard.vue?vue&type=style&index=0&id=391b6db2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391b6db2"]])

export default __exports__